import React from 'react';
import { motion } from 'framer-motion';
export function Partners() {
  return <section className="relative py-32 bg-[#F5F3F0]" data-id="element-215">
      {/* Stone texture background */}
      <div className="absolute inset-0 texture-stone" data-id="element-216" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-218">
          <div className="space-y-12" data-id="element-219">
            <div data-id="element-220">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-221">
                Architects of <br data-id="element-222" />
                <span className="italic font-semibold text-[#A07656]" data-id="element-223">
                  Enduring Value
                </span>
              </h2>
              <p className="text-lg text-[#595959] leading-relaxed max-w-xl" data-id="element-224">
                "We founded Iron Ridge Custom Homes on a simple premise: that a
                home should not just be built for today, but crafted to stand as
                a testament to quality for generations to come."
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-225">
              {[{
              name: 'Jake Luther',
              role: 'Co-Founder & Principal',
              experience: '18 Years Experience'
            }, {
              name: 'Richard Abbey',
              role: 'Co-Founder & Design',
              experience: '22 Years Experience'
            }, {
              name: 'Brandon Ontiveros',
              role: 'Co-Founder & Construction',
              experience: '20 Years Experience'
            }].map((person, index) => <motion.div key={person.name} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="text-center" data-id="element-226">
                  <div className="w-24 h-24 mx-auto mb-5 bg-[#1A1A1A] flex items-center justify-center" data-id="element-227">
                    <span className="text-2xl font-serif font-bold text-[#A07656]" data-id="element-228">
                      {person.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <h3 className="text-xl font-serif font-bold text-[#1A1A1A] mb-1" data-id="element-229">
                    {person.name}
                  </h3>
                  <p className="text-sm text-[#A07656] uppercase tracking-widest font-semibold mb-2" data-id="element-230">
                    {person.role}
                  </p>
                  <p className="text-sm text-[#595959]" data-id="element-231">{person.experience}</p>
                </motion.div>)}
            </div>
          </div>

          <div className="relative hidden lg:block h-full min-h-[600px]" data-id="element-232">
            <div className="absolute top-0 right-0 w-3/4 h-full border-2 border-[#A07656]/30" data-id="element-233" />
            <div className="absolute top-12 right-12 w-3/4 h-full bg-[#E8E4DF] p-12 flex flex-col justify-center" data-id="element-234">
              <div className="absolute inset-0 texture-timber opacity-40" data-id="element-235" />

              <div className="relative" data-id="element-236">
                <h3 className="text-2xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-237">
                  Our Philosophy
                </h3>
                <ul className="space-y-6" data-id="element-238">
                  {['Integrity in every material choice', 'Design that respects context and history', 'Innovation that serves comfort', 'Transparency throughout the process'].map((item, i) => <motion.li key={i} initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: i * 0.1
                }} className="flex items-start gap-4" data-id="element-239">
                      <span className="w-2 h-2 rounded-full bg-[#A07656] mt-2.5 flex-shrink-0" data-id="element-240" />
                      <span className="text-lg text-[#595959]" data-id="element-241">{item}</span>
                    </motion.li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}